export default __webpack_public_path__ + "static/media/icon-editar.fb9a6507.svg";